import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { UserTrackingService } from '@angular/fire/analytics';
import { connectFirestoreEmulator, getFirestore, provideFirestore } from '@angular/fire/firestore';
import { NzIconService } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalService } from 'ng-zorro-antd/modal';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { provideToastr } from 'ngx-toastr';
import { routes } from '../modules/emember/emember.routing';
import { httpErrorInterceptor } from '../services/http-error-interceptor';
import { DataLayerService } from '../modules/share/services/data-layer.service';
import { environment } from '../../environments/environment';
import { membershipInitializing } from '../modules/emember/emeber.initializer';
import { storeProviders } from '../store/store.module';
import { NotificationComponent } from '../modules/share/notification/notification.component';
import { locationStrategy } from '../services/location-strategy/ngx-location-strategies.module';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    locationStrategy({ routeQueryName: 'app', stickyParams: ['page'] }),
    provideFirebaseApp(() => {
      const app = initializeApp(environment.firebaseConfig);
      return app;
    }),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage()),
    provideFirestore(() => {
      const firestore = getFirestore();

      if (environment.emulator) {
        connectFirestoreEmulator(firestore, 'localhost', 8080);
      }

      return firestore;
    }),
    // provideAnalytics(() => {
    //   const platformId = inject(PLATFORM_ID);
    //
    //   if (!isPlatformBrowser(platformId)) {
    //     return null as any;
    //   }
    //
    //   // ⚠️ sync fallback for DI safety
    //   const analytics = getAnalytics();
    //   return analytics;
    // }),
    provideToastr({
      toastComponent: NotificationComponent,
      timeOut: 4000,
      progressBar: false,
      closeButton: true,
    }),
    provideHttpClient(withInterceptors([httpErrorInterceptor])),
    provideRouter(routes),
    NzIconService,
    NzMessageService,
    NzDrawerService,
    NzNotificationService,
    NzModalService,
    DataLayerService,
    {
      provide: Window,
      useValue: window,
    },
    { provide: NZ_I18N, useValue: en_US },
    {
      provide: APP_INITIALIZER,
      useFactory: membershipInitializing,
      multi: true,
    },
    UserTrackingService,
    ...storeProviders,
  ],
};
